import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import '../../../src/styles/healthInfo.css';
// import CustomTooltip from './CustomTooltip';
import ALL_HEALTHY_ICON from '../../images/All_servers_cameras_healthy.png';
import NO_DATA_ICON from '../../images/No_data.png';
import ALERT_ICON from '../../images/alertIcon.png';
import GenericTooltip from '../../generic_components/Tooltip/Tooltip';

ChartJS.register(ArcElement, Tooltip, Legend);


function HealthCharts({ 
    data,
    totalOnlineServers,
    totalOfflineServers,
    totalOnlineDevices,
    totalOfflineDevices,
    totalOnlineAnalytics, 
    totalOfflineAnalytics,
    totalOnlineSwitches,
    totalOfflineSwitches,
    totalOnlineUPS,
    totalOfflineUPS,
    totalServers,
    totalDevices,
    totalAnalytics,
    totalSwitches,
    totalUPS
  }) 
  {

  const isSmallScreen = window.innerWidth < 600;

  const options = {
    plugins: {
      legend: {
        labels: {
          color: '#ccc',
          font: {
            size: 12,
          } 
        },        
      },
    },
    rotation: -90,
    circumference: 180,
    cutout: 60,
    maintainAspectRatio: true,
    responsive: true, 
  };

  // options for smaller screen
  const options_small = {
    plugins: {
      legend: {
        labels: {
          color: '#ccc',
          font: {
            size: 11,
          }
        },        
      },    
     
    },
    rotation: -90,
    circumference: 180,
    cutout: 105, // Use a numerical value without the percentage symbol
    maintainAspectRatio: true,
    responsive: true, 
  };


  // Options for "No Data Available" for bigger screen
  const options_no_data = {
    plugins: {
      legend: {
        labels: {
          padding: 30,
          color: '#ccc',
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            // Customize tooltip for "No Data Available"
            if (data.ups.labels[0] === 'No Data Available') {
              return '';
            } else if (data.switches.labels[0] === 'No Data Available') {
              return '';
            } else if (data.analytics.labels[0] === 'No Data Available') {
              return '';
            } else if (data.devices.labels[0] === 'No Data Available') {
              return '';
            } else if (data.servers.labels[0] === 'No Data Available') {
              return '';
            }
            else {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            }
           
          },
        },
      },
    },
    rotation: -90,
    circumference: 180,
    cutout: 61,
    maintainAspectRatio: true,
    responsive: true,
  };

  // Options for "No Data Available" smaller screen
  const options_small_no_data = {
    plugins: {
      legend: {
        labels: {
          color: '#ccc',
          font: {
            size: 11,
          }
        },        
      },  
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            // Customize tooltip for "No Data Available"
            if (data.ups.labels[0] === 'No Data Available') {
              return '';
            } else if (data.switches.labels[0] === 'No Data Available') {
              return '';
            } else if (data.analytics.labels[0] === 'No Data Available') {
              return '';
            } else if (data.devices.labels[0] === 'No Data Available') {
              return '';
            } else if (data.servers.labels[0] === 'No Data Available') {
              return '';
            }
            else {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            }
           
          },
        },
      },
    },
    rotation: -90,
    circumference: 180,
    cutout: 105, // Use a numerical value without the percentage symbol
    maintainAspectRatio: true,
    responsive: true,
  };

  // set color for offline servers count at doughnut
  let totalOfflineServersColor = '#C82333';
  if (!totalOfflineServers) {
    totalOfflineServersColor = '#22BE63';
  }

  // set color for offline cameras count at doughnut
  let totalOfflineDevicesColor = '#C82333';
  if (!totalOfflineDevices) {
    totalOfflineDevicesColor = '#22BE63';
  }

  // set color for offline cameras count at doughnut
  let totalOfflineAnalyticsColor = '#C82333';
  if (!totalOfflineAnalytics) {
    totalOfflineAnalyticsColor = '#22BE63';
  }

  // set color for offline cameras count at doughnut
  let totalOfflineSwitchesColor = '#C82333';
  if (!totalOfflineSwitches) {
    totalOfflineSwitchesColor = '#22BE63';
  }


  // set color for offline cameras count at doughnut
  let totalOfflineUPSColor = '#C82333';
  if (!totalOfflineUPS) {
    totalOfflineUPSColor = '#22BE63';
  }

  return (
    // For smaller screen
    isSmallScreen ?
    (<div className='chart-container' >
      <div>
        <div className='activity-label-container'>
          <span className='activity-label'>
            Server Activity     
          </span>
        </div>
        <div className='doughnut-small'>
          <Doughnut data={data.servers} options={totalServers ? options_small : options_small_no_data}/>
          {
          // No data icon / No offline data icon / Some offline data icon
          !totalOfflineServers ? (
              !totalServers ?
              <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
              </GenericTooltip>
              :
              <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
              </GenericTooltip>)
            :
            (
              (totalServers === totalOfflineServers) ?
                <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
                :
                <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
            )
            }
          <div className='chart-values' >           
              <span className='chart-offline-number-small' >
                <GenericTooltip content="Total Servers" placement="bottom">
                  <span style={{ color: 'white' }}>{totalServers}</span>
                </GenericTooltip> /{' '}
                <GenericTooltip content="Offline Servers" placement="bottom">
                  <span style={{ color: totalOfflineServersColor }}>{totalOfflineServers}</span>
                </GenericTooltip>
              </span>
             
          </div>
        </div>
      </div>
    
      <div >  
        <div className='activity-label-container'>
          <span className='activity-label'>
            Camera Activity    
          </span>
        </div>
      <div className='doughnut-small'>   
        <Doughnut  data={data.devices} options={totalDevices ? options_small : options_small_no_data} />
        {
          // No data icon / No offline data icon / Some offline data icon
          !totalOfflineDevices ? (
            !totalDevices ?
              <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
              </GenericTooltip>
              :
              <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
              </GenericTooltip>)
          :
          (
            (totalDevices === totalOfflineDevices) ?
              <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
              :
              <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
            )
        }
        <div className='chart-values'>
          <span className='chart-offline-number-small' >
            <GenericTooltip content="Total Cameras" placement="bottom">
              <span style={{ color: 'white' }}>{totalDevices}</span>
            </GenericTooltip> /{' '}
            <GenericTooltip content="Offline Cameras" placement="bottom">
            <span style={{ color: totalOfflineDevicesColor }}>{totalOfflineDevices}</span>
            </GenericTooltip>
          </span>
        </div>
      </div>
      </div>

      <div>
        <div className='activity-label-container'>
          <span className='activity-label'>
            Analytics Activity
          </span>
        </div>
        <div className='doughnut-small'>
          <Doughnut data={data.analytics} options={totalAnalytics ? options_small : options_small_no_data} />
          {
          // No data icon / No offline data icon / Some offline data icon
          !totalOfflineAnalytics ? (
            !totalAnalytics ?
              <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
              </GenericTooltip>
              :
              <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
              </GenericTooltip>)
          :
          (
            (totalAnalytics === totalOfflineAnalytics) ?
              <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
              :
              <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
            )
            }
          <div className='chart-values'>           
              <span className='chart-offline-number-small' >
                <GenericTooltip content="Total Analytics" placement="bottom">
                  <span style={{ color: 'white' }}>{totalAnalytics}</span>
                </GenericTooltip> /{' '}
                <GenericTooltip content="Offline Analytics" placement="bottom">
                  <span style={{ color: totalOfflineAnalyticsColor }}>{totalOfflineAnalytics}</span>
                </GenericTooltip>
              </span>
             
          </div>
        </div>
      </div>

      <div >
        <div className='activity-label-container'>
          <span className='activity-label'>
            UPS Activity     
          </span>
        </div>
        <div className='doughnut-small'>
          <Doughnut data={data.ups} options={totalUPS ? options_small : options_small_no_data} />
          {
          // No data icon / No offline data icon / Some offline data icon
          !totalOfflineUPS ? (
            !totalUPS ?
              <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
              </GenericTooltip>
              :
              <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
              </GenericTooltip>)
          :
          (
            (totalUPS === totalOfflineUPS) ?
              <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
              :
              <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
          )
          }
          <div className='chart-values'>           
              <span className='chart-offline-number-small' >
                <GenericTooltip content="Total UPS" placement="bottom">
                  <span style={{ color: 'white' }}>{totalUPS}</span>
                </GenericTooltip> /{' '}
                <GenericTooltip content="Offline UPS" placement="bottom">
                  <span style={{ color: totalOfflineUPSColor }}>{totalOfflineUPS}</span>
                </GenericTooltip>
              </span>
             
          </div>
        </div>
      </div>

      <div>
        <div className='activity-label-container'>
          <span className='activity-label'>
            Switches  Activity     
          </span>
        </div>
        <div className='doughnut-small'>
          <Doughnut data={data.switches} options={totalSwitches ? options_small : options_small_no_data} />
          {
            // No data icon / No offline data icon / Some offline data icon
          !totalOfflineSwitches ? (
            !totalSwitches ?
              <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
              </GenericTooltip>
              :
              <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
              </GenericTooltip>)
          :
          (
            (totalSwitches=== totalOfflineSwitches) ?
              <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
              :
              <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-3rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
          )
          }
          <div className='chart-values'>           
              <span className='chart-offline-number-small' >
                <GenericTooltip content="Total Switches" placement="bottom">
                  <span style={{ color: 'white' }}>{totalSwitches}</span>
                </GenericTooltip> /{' '}
                <GenericTooltip content="Offline Switches" placement="bottom">
                  <span style={{ color: totalOfflineSwitchesColor }}>{totalOfflineSwitches}</span>
                </GenericTooltip>
              </span>
             
          </div>
        </div>
      </div>


    </div>
    )
    :
    // For bigger screen
    (<div className='chart-container' >
      <div >
        <div className='activity-label-container'>
          <span className='activity-label'>
            Server Activity     
          </span>
        </div>
        <div style={{ position: 'relative', textAlign: 'center', width: "220px", height: "220px" }}>
          <Doughnut data={data.servers} options={totalServers ? options: options_no_data}/>
          {
            // No data icon / No offline data icon / Some offline data icon
            !totalOfflineServers ? (
              !totalServers ?
              <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
              </GenericTooltip>
              :
              <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
              </GenericTooltip>
            )
            : (
              (totalServers === totalOfflineServers) ?
                <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
                :
              <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
              )
          }
          <div className='chart-values'>           
              <span className='chart-offline-number'>
                <GenericTooltip content="Total Servers" placement="bottom">
                  <span style={{ color: 'white' }}>{totalServers}</span>
                </GenericTooltip> /{' '} 
                <GenericTooltip content="Offline Servers" placement="bottom">
                  <span style={{ color: totalOfflineServersColor }}>{totalOfflineServers}</span>
                </GenericTooltip>
              </span>
             
          </div>
        </div>
      </div>
    
      <div >  
        <div className='activity-label-container'>
          <span className='activity-label'>
            Camera Activity     
          </span>
        </div>
      <div style={{ position: 'relative', textAlign: 'center', width: '220px', height: '220px' }}>   
        <Doughnut  data={data.devices} options={totalDevices ? options : options_no_data}/>
          {
            // No data icon / No offline data icon / Some offline data icon
            !totalOfflineDevices ? (
              !totalDevices ?
                <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
                </GenericTooltip>
                :
                <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
                </GenericTooltip> 
            )
            : (
            (totalDevices === totalOfflineDevices) ?
              <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
              :
              <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
              </GenericTooltip>
            )
          }
        <div className='chart-values'>
          <span className='chart-offline-number' >
            <GenericTooltip content="Total Cameras" placement="bottom">
              <span style={{ color: 'white' }}>{totalDevices}</span>
            </GenericTooltip> /{' '}
            <GenericTooltip content="Offline Cameras" placement="bottom">
            <span style={{ color: totalOfflineDevicesColor }}>{totalOfflineDevices}</span>
            </GenericTooltip>
          </span>
        </div>
      </div>
      </div>

      <div >
          <div className='activity-label-container'>
            <span className='activity-label'>
              Analytics Activity     
            </span>
          </div>
        <div style={{ position: 'relative', textAlign: 'center', width: '220px', height: '220px' }}>
          <Doughnut data={data.analytics} options={totalAnalytics ? options : options_no_data}/>
          {
            // No data icon / No offline data icon / Some offline data icon
            !totalOfflineAnalytics ? (
              !totalAnalytics ?
                <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
                </GenericTooltip>
                :
                <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
                </GenericTooltip>
            )
            : (
              (totalAnalytics === totalOfflineAnalytics) ?
                <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
                :
                <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
              )
          }
          <div className='chart-values'>           
              <span className='chart-offline-number' >
                <GenericTooltip content="Total Analytics" placement="bottom">
                  <span style={{ color: 'white' }}>{totalAnalytics}</span>
                </GenericTooltip> /{' '}
                <GenericTooltip content="Offline Analytics" placement="bottom">
                  <span style={{ color: totalOfflineAnalyticsColor }}>{totalOfflineAnalytics}</span>
                </GenericTooltip>
              </span>
             
          </div>
        </div>
      </div>

      <div >
        <div className='activity-label-container'>
          <span className='activity-label'>
            UPS Activity     
          </span>
        </div>
        <div style={{ position: 'relative', textAlign: 'center', width: '220px', height: '220px' }}>
          <Doughnut data={data.ups} options={totalUPS ? options : options_no_data}/>
          {
            // No data icon / No offline data icon / Some offline data icon
            !totalOfflineUPS ? (
              !totalUPS ?
                <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
                </GenericTooltip>
                :
                <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
                </GenericTooltip>
            )
            : (
              (totalUPS === totalOfflineUPS) ?
                 <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
                :
                <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
              )
          }
          <div className='chart-values'>           
              <span className='chart-offline-number' >
                <GenericTooltip content="Total UPS" placement="bottom">
                  <span style={{ color: 'white' }}>{totalUPS}</span>
                </GenericTooltip> /{' '}
                <GenericTooltip content="Offline UPS" placement="bottom">
                  <span style={{ color: totalOfflineUPSColor }}>{totalOfflineUPS}</span>
                </GenericTooltip>
              </span>
             
          </div>
        </div>
      </div>

      <div >
        <div className='activity-label-container'>
          <span className='activity-label'>
            Switches  Activity     
          </span>
        </div>
        <div style={{ position: 'relative', textAlign: 'center', width: '220px', height: '220px' }}>
          <Doughnut data={data.switches} options={totalSwitches ? options : options_no_data}/>
          {
            // No data icon / No offline data icon / Some offline data icon
            !totalOfflineSwitches ? (
              !totalSwitches ?
                <GenericTooltip content="No data" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={NO_DATA_ICON} alt="No data icon"/>
                </GenericTooltip>
                :
                <GenericTooltip content="All healthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALL_HEALTHY_ICON} alt="All healthy icon"/>
                </GenericTooltip>
            )
            : (
              (totalSwitches === totalOfflineSwitches) ?
                <GenericTooltip content="All unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
                :
                <GenericTooltip content="Some unhealthy" placement="bottom" tooltipStyle={{marginTop: '-2rem'}}>
                  <img className='doughnut-alert-icon' src={ALERT_ICON} alt=""/>
                </GenericTooltip>
              )
          }
          <div className='chart-values'>           
              <span className='chart-offline-number' >
                <GenericTooltip content="Total Switches" placement="bottom">
                  <span style={{ color: 'white' }}>{totalSwitches}</span>
                </GenericTooltip> /{' '}
                <GenericTooltip content="Offline Switches" placement="bottom">
                  <span style={{ color: totalOfflineSwitchesColor }}>{totalOfflineSwitches}</span>
                </GenericTooltip>
              </span>
             
          </div>
        </div>
      </div>

    </div>
    )
  );
}

export default HealthCharts;
